import symbols from '@/constants/symbols'

export default class alertWardInfoLayer {
	constructor(elevatedThreshold, criticalThreshold) {
		this.layer = {
			title: 'Ward Info',
			fields: [
				{
					name: 'ObjectID',
					alias: 'ObjectID',
					type: 'oid'
				},
				{
					name: 'WARD',
					type: 'integer'
				},
				{
					name: 'crew',
					type: 'string'
				},
				{
					name: 'incident',
					type: 'string'
				},
				{
					name: 'workorders',
					type: 'string'
				},
				{
					name: 'elevatedThreshold',
					type: 'integer'
				},
				{
					name: 'criticalThreshold',
					type: 'integer'
				}
			],
			labelsVisible: true,
			labelingInfo: [symbols.wardIncidentLabel, symbols.alertLevel1Label, symbols.alertLevel2Label],
			objectIdField: 'ObjectID',
			geometryType: 'point',
			outFields: ['*'],
			spatialReference: { wkid: 26985 },
			source: [],
			refreshInterval: 0.05,
			minScale: 200000,
			maxScale: 50000,
			renderer: {
				type: 'class-breaks',
				field: 'incident',
				defaultSymbol: symbols.alertWardInfoRed,
				classBreakInfos: [
					{
						minValue: elevatedThreshold,
						maxValue: criticalThreshold - 1,
						symbol: symbols.alertWardInfoYellow
					},
					{
						minValue: 0,
						maxValue: elevatedThreshold - 1,
						symbol: symbols.alertWardInfoGreen
					}
				]
			}
		}
	}
}
